var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.events),function(event,index){return _c('event-item',{key:index,attrs:{"event":event,"side":(index % 2) === 0 ? 'left' : 'right'}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }